/**
 * Cliente do Calendário da Season.
 *
 * <p>Como a aba Cenas: todas as rotas ficam sob `/mundo/calendario`, e nenhuma delas
 * escreve em outra coleção — o calendário referencia as fichas do mundo pelos
 * endpoints que já existem e escreve apenas as próprias seasons e acontecimentos.
 */
import { api } from '../../../api/cliente';
import type { Acontecimento, Calendario, Season, SeasonDetalhe } from './calendarioTipos';

const BASE = '/api/projetos/mistik-island/mundo/calendario';

export function calendario(): Promise<Calendario> {
  return api<Calendario>(BASE);
}

export function season(id: number): Promise<SeasonDetalhe> {
  return api<SeasonDetalhe>(`${BASE}/seasons/${id}`);
}

export function criarSeason(corpo: { nome: string; diasTotal?: number }): Promise<Season> {
  return api<Season>(`${BASE}/seasons`, { method: 'POST', body: JSON.stringify(corpo) });
}

export function salvarSeason(
  id: number,
  mudancas: { nome?: string; diasTotal?: number }
): Promise<SeasonDetalhe> {
  return api<SeasonDetalhe>(`${BASE}/seasons/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(mudancas),
  });
}

/** Sem `confirmado`, uma season com acontecimentos responde 409 e a tela pergunta. */
export function excluirSeason(id: number, confirmado = false): Promise<void> {
  return api<void>(`${BASE}/seasons/${id}?confirmar=${confirmado}`, { method: 'DELETE' });
}

export function criarAcontecimento(
  seasonId: number,
  corpo: Record<string, unknown>
): Promise<Acontecimento> {
  return api<Acontecimento>(`${BASE}/seasons/${seasonId}/acontecimentos`, {
    method: 'POST',
    body: JSON.stringify(corpo),
  });
}

export function salvarAcontecimento(
  id: number,
  mudancas: Record<string, unknown>
): Promise<Acontecimento> {
  return api<Acontecimento>(`${BASE}/acontecimentos/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(mudancas),
  });
}

export function excluirAcontecimento(id: number): Promise<void> {
  return api<void>(`${BASE}/acontecimentos/${id}`, { method: 'DELETE' });
}
